import React from "react";

import { StyledLabel } from "./styles";

export const Label: React.FC = ({ children, ...rest }) => {
  return <StyledLabel {...rest}>{children}</StyledLabel>;
};
